(function ($) {
    const $testimonialSlider = $('#testimonial-slider');

    if ($('#testimonial-slider .slide').length > 1) {
        // Initialize region testimonial carousel
        $testimonialSlider.slick({
            autoplay: true,
            autoplaySpeed: 7000,
            infinite: true,
            dots: false,
            arrows: true,
            fade: false,
            prevArrow:
                "<button type='button' class='slick-prev'><i class='fal fa-chevron-left'></i></button>",
            nextArrow:
                "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
            // responsive: [
            //     {
            //         breakpoint: 992,
            //         settings: {
            //             arrows: true,
            //             dots: false,
            //         },
            //     },
            // ],
        });
    }
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/slider-controller.js